import Cookies from "js-cookie";
import { post } from "@/utils/utils";

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get("sidebarStatus"),
      withoutAnimation: false
    },
    device: "desktop",
    storeName: ""
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set("sidebarStatus", 1);
      } else {
        Cookies.set("sidebarStatus", 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set("sidebarStatus", 1);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    QUERY_DICT() {},
    QUERT_NEW_ORDER() {},
    QUERT_PAY_ORDER_NUM() {},
    QUERT_TCPS_ORDER_NUM() {},
    QUERT_TOKEN() {}
  },
  actions: {
    queryDict: ({ commit }, params) => {
      return post({
        commit,
        url: `/sys/common/getUiTextByTextCode`,
        name: "QUERY_DICT",
        params,
        isQueryString: true
      });
    },
    ToggleSideBar: ({ commit }) => {
      commit("TOGGLE_SIDEBAR");
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit("CLOSE_SIDEBAR", withoutAnimation);
    },
    ToggleDevice({ commit }, device) {
      commit("TOGGLE_DEVICE", device);
    },
    queryNewOrde({ commit }, params) {
      return post({
        commit,
        url: `order/query_new_order?false`,
        name: "QUERT_NEW_ORDER",
        params
      });
    },
    queryPayOrderNum({ commit }, params) {
      return post({
        commit,
        url: `/order/query_payOrderNum`,
        name: "QUERT_PAY_ORDER_NUM",
        params
      });
    },
    queryTcpsOrderNum({ commit }, params) {
      return post({
        commit,
        url: `/order/tcpsOrderNum`,
        name: "QUERT_TCPS_ORDER_NUM",
        params
      });
    },
    queryToken({ commit }, params) {
      return post({
        commit,
        url: `/shop/order/get_token`,
        name: "QUERT_TOKEN",
        params
      });
    }
  }
};

export default app;
